import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Tooltip } from 'react-leaflet';

// the syntax used inside `styled()` is a workaround for this issue:
// https://github.com/styled-components/styled-components/issues/1449
// eslint-disable-next-line react/jsx-props-no-spreading
const MarkerTooltip = styled(props => <Tooltip {...props} />).attrs(props => ({
  // 6(px) is the default height of the pointer element in the Leaflet code
  offset: [props.offset[0], props.offset[1] - props.pointerSize + 6],
}))`
  border-radius: 5px;
  color: ${props => props.theme.primaryFontColor};
  font-size: 18px;
  font-weight: 400;
  line-height: 20px;
  max-width: ${props => props.maxWidth}px;
  padding: 5px 8px;
  text-align: center;
  white-space: normal;
  width: max-content;

  /* replace the box shadow with a drop shadow so that the shadow is
     drawn around the text dialog and the child pointer element */
  box-shadow: unset;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.4));

  /* styling for the pointer element of the tooltip */
  &::before {
    border-width: ${props => props.pointerSize}px;
    margin-bottom: ${props => -props.pointerSize * 2}px;
    margin-left: ${props => -props.pointerSize}px;
  }
`;

MarkerTooltip.propTypes = {
  /** [x, y] offset of tooltip pointer from center of marker (Leaflet) */
  offset: PropTypes.arrayOf(PropTypes.number),

  /** Number of pixels used as height and width of tooltip pointer element */
  pointerSize: PropTypes.number,

  /** Direction to open the tooltip: right, left, top, bottom, center, auto (Leaflet) */
  direction: PropTypes.string,

  /** Whether to open the tooltip permanently or only on mouseover (Leaflet) */
  permanent: PropTypes.bool,

  /** Tooltip container opacity (Leaflet) */
  opacity: PropTypes.number,

  /** Maximum width of the tooltip bubble element in pixels */
  maxWidth: PropTypes.number,
};

MarkerTooltip.defaultProps = {
  offset: [0, 0],
  pointerSize: 8,
  direction: 'top',
  permanent: false,
  opacity: 1.0,
  maxWidth: 200,
};

export default MarkerTooltip;
